import 'slick-carousel';

const sliderHistory = $('.js-slider-history').slick({
  slidesToShow: 1,
  asNavFor: '.js-slider-history-dates',
  infinite: true
});

const sliderHistoryDates = $('.js-slider-history-dates').slick({
  slidesToShow: 1,
  variableWidth: true,
  arrows: false,
  focusOnSelect: true,
  asNavFor: '.js-slider-history',
  infinite: true
});
